{
  "axios-context-provider.setting-up-environnement": {
    "translation": "Configuration de votre espace de travail"
  },
  "ensure-user.error-loading-user-infos": {
    "translation": "Une erreur est survenue lors du chargement de vos informations"
  },
  "ensure-user.loading-user-infos": {
    "translation": "Chargement des informations du compte"
  },
  "moby.error.generic": {
    "translation": "Une erreur s'est produite. Mobsuccess a été alerté et travaille à résoudre le problème."
  },
  "monitoring.table.agent": {
    "translation": "Agent"
  },
  "monitoring.table.columns.changes": {
    "translation": "Modifications"
  },
  "monitoring.table.columns.date": {
    "translation": "Date"
  },
  "monitoring.table.columns.entity-type": {
    "translation": "Type d'entité"
  },
  "monitoring.table.columns.entity-uuid": {
    "translation": "UUID d'entité"
  },
  "monitoring.table.columns.operation": {
    "translation": "Opération"
  },
  "monitoring.table.columns.user": {
    "translation": "Utilisateur"
  },
  "monitoring.table.filter.all": {
    "translation": "Tout"
  },
  "monitoring.table.filter.all.tooltip": {
    "translation": "Afficher toutes les entrées, y compris les mises à jour sans changement"
  },
  "monitoring.table.filter.changes-only": {
    "translation": "Changements"
  },
  "monitoring.table.filter.changes-only.tooltip": {
    "translation": "Masquer les mises à jour sans changement effectif"
  },
  "monitoring.table.loading": {
    "translation": "Chargement des données de monitoring..."
  },
  "monitoring.table.not-available": {
    "translation": "N/A"
  },
  "monitoring.table.system-user": {
    "translation": "Système"
  },
  "mutation-error.toast.generic": {
    "translation": "Le serveur a refusé la requête. Vérifiez votre saisie et réessayez."
  },
  "mutation-error.toast.title": {
    "translation": "L'action a échoué"
  },
  "navigation-blocker.cancel": {
    "translation": "Annuler"
  },
  "navigation-blocker.form.description": {
    "translation": "Certains champs de ce formulaire ont été modifiés. Si vous quittez cette page, vous perdrez les modifications non enregistrées."
  },
  "navigation-blocker.form.title": {
    "translation": "Voulez-vous vraiment quitter cette page ?"
  },
  "navigation-blocker.proceed": {
    "translation": "Continuer"
  },
  "pending-page.loading-user-infos": {
    "translation": "Chargement des informations du compte"
  },
  "src.features.use-service-pages.backoffice-client": {
    "translation": "Gérer les clients"
  },
  "src.features.use-service-pages.backoffice-kits": {
    "translation": "Gérer les kits"
  },
  "src.features.use-service-pages.backoffice-orders": {
    "translation": "Gérer les commandes"
  },
  "src.features.use-service-pages.backoffice-statistics": {
    "translation": "Statistiques d'utilisation"
  },
  "src.features.use-service-pages.bo-dashboard-clients": {
    "translation": "Clients & accès"
  },
  "src.features.use-service-pages.campaigns": {
    "translation": "Campagnes"
  },
  "src.features.use-service-pages.dashboard-manager": {
    "translation": "Dashboard manager"
  },
  "src.features.use-service-pages.detailed-reporting": {
    "translation": "Rapports détaillés"
  },
  "src.features.use-service-pages.docs": {
    "translation": "Doc utilisateurs"
  },
  "src.features.use-service-pages.faq": {
    "translation": "FAQ"
  },
  "src.features.use-service-pages.kits": {
    "translation": "Souscrire à des kits"
  },
  "src.features.use-service-pages.my-subscribed-kits": {
    "translation": "Mes kits souscrits"
  },
  "src.features.use-service-pages.overview": {
    "translation": "Vue d'ensemble"
  },
  "src.features.use-service-pages.playground": {
    "translation": "Playground"
  },
  "src.public.auth.sign-out-error.description": {
    "translation": "Impossible de déconnecter la session"
  },
  "src.public.auth.sign-out-error.title": {
    "translation": "Une erreur est survenue"
  },
  "src.public.color.channel": {
    "placeholders": {
      "channel": ["channel"],
      "value": ["value"],
      "min": ["min"],
      "max": ["max"]
    },
    "translation": "La valeur {value} de la couleur {channel} doit être comprise entre {min} et {max}"
  },
  "src.public.color.format": {
    "placeholders": {
      "format": ["format"]
    },
    "translation": "La valeur de la couleur doit être dans le format {format}"
  },
  "src.public.custom-themes.error-description": {
    "translation": "Veuillez réessayer plus tard"
  },
  "src.public.custom-themes.error-title": {
    "translation": "Une erreur est survenue"
  },
  "src.public.customly.components.preview-container.retry": {
    "translation": "Relancer le playground"
  },
  "src.public.i18n.mt-edit.badge.label": {
    "translation": "Traductions"
  },
  "src.public.i18n.mt-edit.badge.title": {
    "placeholders": {
      "shortcut": ["shortcutLabel"]
    },
    "translation": "Mode édition Mobtranslate — clique un texte souligné pour l'éditer (Alt+clic sur les boutons, menus et champs). {shortcut} : afficher/masquer l'overlay (mt-edit=0 pour quitter)."
  },
  "src.public.i18n.mt-edit.banner.editing": {
    "placeholders": {
      "locale": ["localeLabel(opts.locale)"]
    },
    "translation": "Tu édites : {locale}"
  },
  "src.public.i18n.mt-edit.banner.source": {
    "placeholders": {
      "locale": ["localeLabel(opts.locale)"]
    },
    "translation": "SOURCE — {locale} : modifie le texte d'origine, les traductions repassent « à revoir »"
  },
  "src.public.i18n.mt-edit.close": {
    "translation": "Fermer"
  },
  "src.public.i18n.mt-edit.help.alt-click": {
    "translation": "Éditer un bouton, un menu, un lien ou un champ"
  },
  "src.public.i18n.mt-edit.help.alt-hold": {
    "translation": "Figer les éléments au survol (tooltips, menus)"
  },
  "src.public.i18n.mt-edit.help.click": {
    "translation": "Éditer un texte souligné"
  },
  "src.public.i18n.mt-edit.help.escape": {
    "translation": "Fermer le panneau"
  },
  "src.public.i18n.mt-edit.help.kbd-click": {
    "translation": "Clic"
  },
  "src.public.i18n.mt-edit.help.title": {
    "translation": "Raccourcis du mode édition"
  },
  "src.public.i18n.mt-edit.help.toggle": {
    "translation": "Afficher/masquer le soulignage"
  },
  "src.public.i18n.mt-edit.open-in-mobtranslate": {
    "translation": "Ouvrir dans Mobtranslate"
  },
  "src.public.i18n.mt-edit.quit": {
    "translation": "Quitter le mode édition"
  },
  "src.public.i18n.mt-edit.save": {
    "translation": "Enregistrer"
  },
  "src.public.i18n.mt-edit.sign-in": {
    "translation": "Se connecter à Mobtranslate ↗"
  },
  "src.public.i18n.mt-edit.status.auth-error": {
    "translation": "Session Mobtranslate absente — connecte-toi puis réessaie :"
  },
  "src.public.i18n.mt-edit.status.error": {
    "translation": "Échec (session Mobtranslate absente ou accès bloqué) — utilise le lien ci-dessous."
  },
  "src.public.i18n.mt-edit.status.saved": {
    "translation": "Enregistré dans Mobtranslate."
  },
  "src.public.i18n.mt-edit.status.saved-source": {
    "translation": "Source corrigée (traductions repassées « à revoir »)."
  },
  "src.public.i18n.mt-edit.status.saving": {
    "translation": "Enregistrement…"
  },
  "src.public.i18n.mt-edit.status.suggest-error": {
    "translation": "Échec de la suggestion IA."
  },
  "src.public.i18n.mt-edit.status.suggested": {
    "translation": "Suggestion insérée — vérifie puis enregistre."
  },
  "src.public.i18n.mt-edit.status.suggesting": {
    "translation": "Suggestion IA…"
  },
  "src.public.i18n.mt-edit.suggest": {
    "translation": "Suggérer"
  },
  "src.public.react-ui.account-dropdown.search-placeholder": {
    "translation": "Rechercher..."
  },
  "src.public.react-ui.advertiser-picker.account-info": {
    "placeholders": {
      "accountId": ["accountId"],
      "clientId": ["clientId"]
    },
    "translation": "Annonceur {accountId} · Agence {clientId}"
  },
  "src.public.react-ui.advertiser-picker.add-to-favorites": {
    "translation": "Ajouter aux favoris"
  },
  "src.public.react-ui.advertiser-picker.close-hint": {
    "translation": "pour fermer"
  },
  "src.public.react-ui.advertiser-picker.favorites-filter": {
    "translation": "Favoris"
  },
  "src.public.react-ui.advertiser-picker.favorites-section": {
    "translation": "Favoris"
  },
  "src.public.react-ui.advertiser-picker.navigate-hint": {
    "translation": "pour naviguer"
  },
  "src.public.react-ui.advertiser-picker.no-results": {
    "translation": "Aucun résultat trouvé."
  },
  "src.public.react-ui.advertiser-picker.no-selection": {
    "translation": "Aucun annonceur sélectionné"
  },
  "src.public.react-ui.advertiser-picker.placeholder": {
    "translation": "Rechercher..."
  },
  "src.public.react-ui.advertiser-picker.remove-from-favorites": {
    "translation": "Retirer des favoris"
  },
  "src.public.react-ui.advertiser-picker.select-hint": {
    "translation": "pour sélectionner"
  },
  "src.public.react-ui.advertiser-picker.toggle-hint": {
    "translation": "pour basculer"
  },
  "src.public.react-ui.advertiser-picker.toggle-tooltip": {
    "placeholders": {
      "shortcut": ["shortcut"]
    },
    "translation": "Utilisez {shortcut} pour basculer"
  },
  "src.public.react-ui.audio-player.error": {
    "translation": "L'audio n'a pu être chargé"
  },
  "src.public.react-ui.audio-player.loading": {
    "translation": "L'audio est en cours de chargement"
  },
  "src.public.react-ui.audio-player.pause": {
    "translation": "Mettre en pause"
  },
  "src.public.react-ui.audio-player.play": {
    "translation": "Lancer l'audio"
  },
  "src.public.react-ui.autocomplete.next-page": {
    "translation": "Charger la page suivante"
  },
  "src.public.react-ui.calendar.month": {
    "translation": "Mois"
  },
  "src.public.react-ui.calendar.next-month": {
    "translation": "Mois suivant"
  },
  "src.public.react-ui.calendar.others": {
    "translation": "autres"
  },
  "src.public.react-ui.calendar.previous-month": {
    "translation": "Mois précédent"
  },
  "src.public.react-ui.calendar.today": {
    "translation": "Aujourd'hui"
  },
  "src.public.react-ui.calendar.toggle-all-items": {
    "translation": "Voir tous les éléments"
  },
  "src.public.react-ui.calendar.two-months": {
    "translation": "2 mois"
  },
  "src.public.react-ui.calendar.week-letter": {
    "translation": "S"
  },
  "src.public.react-ui.calendar.year": {
    "translation": "Année"
  },
  "src.public.react-ui.chat.empty-subtitle": {
    "translation": "Aucun message ne correspond à vos filtres"
  },
  "src.public.react-ui.chat.empty-title": {
    "translation": "Aucun message"
  },
  "src.public.react-ui.chat.labels.available-tags": {
    "translation": "Tags disponibles"
  },
  "src.public.react-ui.chat.labels.back-to-conversation": {
    "translation": "Retour à la conversation"
  },
  "src.public.react-ui.chat.labels.favorite-button": {
    "translation": "Favoris"
  },
  "src.public.react-ui.chat.labels.favorite-count": {
    "placeholders": {
      "count": ["count"]
    },
    "translation": "{count} favori(s)"
  },
  "src.public.react-ui.chat.labels.selected-tags": {
    "translation": "Tags sélectionnés"
  },
  "src.public.react-ui.chat.loading": {
    "translation": "Chargement..."
  },
  "src.public.react-ui.chat.placeholders.search": {
    "translation": "Rechercher des messages..."
  },
  "src.public.react-ui.chat.send-button": {
    "translation": "Envoyer"
  },
  "src.public.react-ui.command-menu.close-hint": {
    "translation": "pour fermer"
  },
  "src.public.react-ui.command-menu.empty": {
    "translation": "Aucun résultat trouvé"
  },
  "src.public.react-ui.command-menu.navigate-hint": {
    "translation": "pour naviguer"
  },
  "src.public.react-ui.command-menu.placeholder": {
    "translation": "Rechercher..."
  },
  "src.public.react-ui.command-menu.select-hint": {
    "translation": "pour sélectionner"
  },
  "src.public.react-ui.command-menu.toggle-hint": {
    "translation": "pour ouvrir/fermer"
  },
  "src.public.react-ui.data-editor.csv.apply": {
    "translation": "Appliquer"
  },
  "src.public.react-ui.data-editor.csv.format": {
    "translation": "Formater"
  },
  "src.public.react-ui.data-editor.csv.revert": {
    "translation": "Réinitialiser"
  },
  "src.public.react-ui.data-editor.csv.unsaved-changes": {
    "translation": "Changements non sauvegardés"
  },
  "src.public.react-ui.data-editor.csv.up-to-date": {
    "translation": "Aucun changement"
  },
  "src.public.react-ui.data-editor.records": {
    "placeholders": {
      "count": ["count"]
    },
    "translation": "{count, plural, zero {aucun registre} one {# registre} other {# registres}}"
  },
  "src.public.react-ui.data-editor.upload.error": {
    "translation": "Le fichier n'a pas pu être chargé"
  },
  "src.public.react-ui.data-editor.views.csv": {
    "translation": "Vue CSV"
  },
  "src.public.react-ui.data-editor.views.table": {
    "translation": "Vue Tableau"
  },
  "src.public.react-ui.date-range-picker.from": {
    "translation": "Du"
  },
  "src.public.react-ui.date-range-picker.last-days": {
    "placeholders": {
      "days": ["14", "3", "30", "7", "90"]
    },
    "translation": "Les {days} derniers jours"
  },
  "src.public.react-ui.date-range-picker.last-month": {
    "translation": "Le mois dernier"
  },
  "src.public.react-ui.date-range-picker.last-quarter": {
    "translation": "Le trimestre dernier"
  },
  "src.public.react-ui.date-range-picker.last-week": {
    "translation": "La semaine dernière"
  },
  "src.public.react-ui.date-range-picker.last-year": {
    "translation": "L'année dernière"
  },
  "src.public.react-ui.date-range-picker.range-placeholder": {
    "translation": "Filtrer par date"
  },
  "src.public.react-ui.date-range-picker.reset": {
    "translation": "Réinitialiser"
  },
  "src.public.react-ui.date-range-picker.this-month": {
    "translation": "Ce mois-ci"
  },
  "src.public.react-ui.date-range-picker.this-quarter": {
    "translation": "Ce trimestre"
  },
  "src.public.react-ui.date-range-picker.this-week": {
    "translation": "Cette semaine"
  },
  "src.public.react-ui.date-range-picker.this-year": {
    "translation": "Cette année"
  },
  "src.public.react-ui.date-range-picker.to": {
    "translation": "au"
  },
  "src.public.react-ui.date-range-picker.today": {
    "translation": "Aujourd'hui"
  },
  "src.public.react-ui.date-range-picker.yesterday": {
    "translation": "Hier"
  },
  "src.public.react-ui.date-time-picker.ok": {
    "translation": "OK"
  },
  "src.public.react-ui.error-page.contact-support": {
    "translation": "N'hésitez pas à contacter le support si le problème persiste."
  },
  "src.public.react-ui.error-page.description": {
    "translation": "Une erreur est survenue, veuillez réessayer plus tard."
  },
  "src.public.react-ui.error-page.go-back": {
    "translation": "Retour"
  },
  "src.public.react-ui.error-page.go-home": {
    "translation": "Retourner à l'accueil"
  },
  "src.public.react-ui.error-page.title": {
    "translation": "Erreur interne"
  },
  "src.public.react-ui.field.char-count": {
    "placeholders": {
      "count": ["count"],
      "limit": ["limit"]
    },
    "translation": "{count}/{limit} caractères"
  },
  "src.public.react-ui.field.optional": {
    "translation": "Optionnel"
  },
  "src.public.react-ui.file-upload.rejected.reason": {
    "placeholders": {
      "reasons": ["reasons.join(\", \")"]
    },
    "translation": "Rejeté pour les raisons suivantes: {reasons}"
  },
  "src.public.react-ui.file-upload.rejected.title": {
    "placeholders": {
      "name": ["name"]
    },
    "translation": "Le ficher \"{name}\" a été rejeté"
  },
  "src.public.react-ui.filters.search-placeholder": {
    "translation": "Rechercher"
  },
  "src.public.react-ui.general.confirm-reset.cancel": {
    "translation": "Annuler"
  },
  "src.public.react-ui.general.confirm-reset.confirm": {
    "translation": "Réinitialiser"
  },
  "src.public.react-ui.general.confirm-reset.description": {
    "translation": "Êtes-vous sûr de vouloir réinitialiser ? Toutes les données seront perdues."
  },
  "src.public.react-ui.general.confirm-reset.title": {
    "translation": "Réinitialiser toutes les modifications ?"
  },
  "src.public.react-ui.general.confirm-submit.cancel": {
    "translation": "Annuler"
  },
  "src.public.react-ui.general.confirm-submit.confirm": {
    "translation": "Confirmer"
  },
  "src.public.react-ui.general.confirm-submit.title": {
    "translation": "Souhaitez-vous continuer ?"
  },
  "src.public.react-ui.general.reset": {
    "translation": "Réinitialiser"
  },
  "src.public.react-ui.general.save": {
    "translation": "Sauvegarder"
  },
  "src.public.react-ui.general.save-and-close": {
    "translation": "Sauvegarder et fermer"
  },
  "src.public.react-ui.header-account-picker.search-placeholder": {
    "translation": "Rechercher..."
  },
  "src.public.react-ui.header-account-picker.select-account": {
    "translation": "Sélectionner un compte"
  },
  "src.public.react-ui.moby.ask-a-question": {
    "translation": "Posez une question ici"
  },
  "src.public.react-ui.moby.cancel": {
    "translation": "Annuler"
  },
  "src.public.react-ui.moby.copied-message": {
    "translation": "Copié"
  },
  "src.public.react-ui.moby.copy-message": {
    "translation": "Copier le message"
  },
  "src.public.react-ui.moby.description": {
    "translation": "L'assistant IA de Mobsuccess"
  },
  "src.public.react-ui.moby.download-file": {
    "translation": "Télécharger le fichier"
  },
  "src.public.react-ui.moby.download-file-error": {
    "translation": "Téléchargement échoué"
  },
  "src.public.react-ui.moby.downloading-file": {
    "translation": "Téléchargement..."
  },
  "src.public.react-ui.moby.happy-with-this-conv": {
    "translation": "Heureux de cet échange ?"
  },
  "src.public.react-ui.moby.open-chat": {
    "translation": "Ouvrir le chat Moby"
  },
  "src.public.react-ui.moby.reset": {
    "translation": "Réinitialiser"
  },
  "src.public.react-ui.moby.reset-request": {
    "translation": "Réinitialiser la requête"
  },
  "src.public.react-ui.moby.reset-request-description": {
    "translation": "Voulez-vous vraiment effacer et réinitialiser votre requête ?"
  },
  "src.public.react-ui.moby.send": {
    "translation": "Envoyer"
  },
  "src.public.react-ui.moby.title": {
    "translation": "Moby"
  },
  "src.public.react-ui.not-allowed.description": {
    "translation": "Vous n'êtes pas autorisé à accéder à cette page."
  },
  "src.public.react-ui.not-allowed.go-back": {
    "translation": "Retour"
  },
  "src.public.react-ui.not-allowed.go-home": {
    "translation": "Retourner à l'accueil"
  },
  "src.public.react-ui.not-allowed.request-id": {
    "placeholders": {
      "id": ["id"]
    },
    "translation": "ID de la requête : {id}"
  },
  "src.public.react-ui.not-allowed.title": {
    "translation": "Accès refusé"
  },
  "src.public.react-ui.not-found-error-page.clear-filters": {
    "translation": "Réinitialiser les filtres"
  },
  "src.public.react-ui.not-found-error-page.description": {
    "translation": "Les filtres que vous avez appliqués ne correspondent à aucun résultat."
  },
  "src.public.react-ui.not-found-error-page.title": {
    "translation": "Aucun résultat"
  },
  "src.public.react-ui.pagination.first-page": {
    "translation": "Première page"
  },
  "src.public.react-ui.pagination.last-page": {
    "translation": "Dernière page"
  },
  "src.public.react-ui.pagination.next-page": {
    "translation": "Page suivante"
  },
  "src.public.react-ui.pagination.page-size-label": {
    "translation": "Afficher"
  },
  "src.public.react-ui.pagination.page-size-options": {
    "placeholders": {
      "size": ["size"]
    },
    "translation": "{size} lignes"
  },
  "src.public.react-ui.pagination.previous-page": {
    "translation": "Page précédente"
  },
  "src.public.react-ui.select.copy": {
    "translation": "Copier"
  },
  "src.public.react-ui.select.copy-success": {
    "translation": "Sélection copiée dans le presse-papiers"
  },
  "src.public.react-ui.select.copy-tooltip": {
    "translation": "Copier la sélection dans le presse-papiers"
  },
  "src.public.react-ui.select.paste": {
    "translation": "Coller depuis le presse-papiers"
  },
  "src.public.react-ui.select.paste-error-description": {
    "translation": "Les éléments collés n'étaient pas au bon format. Assurez-vous d'utiliser le format \"id_1;id_2\""
  },
  "src.public.react-ui.select.paste-error-title": {
    "translation": "Erreur de collage"
  },
  "src.public.react-ui.select.paste-tooltip": {
    "translation": "Remplacer la sélection actuelle par les valeurs du presse-papiers"
  },
  "src.public.react-ui.select.remove-all": {
    "translation": "Tout effacer"
  },
  "src.public.react-ui.select.select-all": {
    "translation": "Tout sélectionner"
  },
  "src.public.react-ui.sidebar.admin": {
    "translation": "Administration"
  },
  "src.public.react-ui.sidebar.edit-translations": {
    "translation": "Éditer les traductions"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.cancel": {
    "translation": "Annuler"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.confirm": {
    "translation": "Valider"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.description": {
    "translation": "Sélectionnez votre langue"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.error-description": {
    "translation": "Cette langue n'est pas supportée"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.error-title": {
    "translation": "Erreur au chargement de la langue"
  },
  "src.public.react-ui.sidebar.language-selector-dialog.title": {
    "translation": "Changer de langue"
  },
  "src.public.react-ui.sidebar.logout": {
    "translation": "Se déconnecter"
  },
  "src.public.react-ui.sidebar.open-menu": {
    "translation": "Ouvrir le menu"
  },
  "src.public.react-ui.table.arrange-columns": {
    "translation": "Modifier la disposition des colonnes"
  },
  "src.public.react-ui.table.collapse-all-rows": {
    "translation": "Masquer tous les détails"
  },
  "src.public.react-ui.table.collapse-row": {
    "translation": "Masquer le détail"
  },
  "src.public.react-ui.table.expand-all-rows": {
    "translation": "Afficher tous les détails"
  },
  "src.public.react-ui.table.expand-row": {
    "translation": "Afficher le détail"
  },
  "utils.empty-account-infos": {
    "translation": "Aucun compte disponible"
  },
  "utils.loading-account-infos": {
    "translation": "Chargement des informations du compte"
  },
  "validation.file.allowedTypes": {
    "placeholders": {
      "types": [
        "Array.isArray(types) ? types.join(\", \") : types",
        "types.join(\", \")"
      ]
    },
    "translation": "Le type du fichier doit être compris dans: {types}"
  },
  "validation.file.audio.maximumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "L'audio doit avoir une durée maximum de {duration} secondes"
  },
  "validation.file.audio.minimumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "L'audio doit avoir une durée minimum de {duration} secondes"
  },
  "validation.file.image.aspectRatio": {
    "placeholders": {
      "ratios": ["ratios.map(([w, h]) => `${w}:${h}`).join(\", \")"]
    },
    "translation": "Le ratio de l'image doit être l'un des suivants: {ratios}"
  },
  "validation.file.image.dimensions": {
    "placeholders": {
      "sizes": ["sizes.map(([w, h]) => `${w}x${h}`).join(\", \")"]
    },
    "translation": "Les dimensions de l'image doivent être l'une des suivantes: {sizes}"
  },
  "validation.file.maximumSize": {
    "placeholders": {
      "size": ["size"]
    },
    "translation": "La taille du fichier ne peux dépasser {size} bytes"
  },
  "validation.file.minimumSize": {
    "placeholders": {
      "size": ["size"]
    },
    "translation": "La taille du fichier ne peux être inférieur à {size} bytes"
  },
  "validation.file.mustBeAudio": {
    "translation": "Le fichier doit être un audio"
  },
  "validation.file.mustBeImage": {
    "translation": "Le fichier doit être une image"
  },
  "validation.file.mustBeVideo": {
    "translation": "Le fichier doit être une vidéo"
  },
  "validation.file.namePattern": {
    "placeholders": {
      "pattern": ["pattern.source"]
    },
    "translation": "Le nom du fichier doit correspondre au pattern: {pattern}"
  },
  "validation.file.video.aspectRatio": {
    "placeholders": {
      "ratios": ["ratios.map(([w, h]) => `${w}:${h}`).join(\", \")"]
    },
    "translation": "Le ratio de la vidéo doit être l'un des suivants: {ratios}"
  },
  "validation.file.video.dimensions": {
    "placeholders": {
      "sizes": ["sizes.map(([w, h]) => `${w}x${h}`).join(\", \")"]
    },
    "translation": "Les dimensions de la vidéo doivent être l'une des suivantes: {sizes}"
  },
  "validation.file.video.maximumBitrate": {
    "placeholders": {
      "byterate": ["byterate"]
    },
    "translation": "La vidéo doit avoir un débit maximum de {byterate}"
  },
  "validation.file.video.maximumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "La vidéo doit avoir une durée maximum de {duration} secondes"
  },
  "validation.file.video.minimumBitrate": {
    "placeholders": {
      "byterate": ["byterate"]
    },
    "translation": "La vidéo doit avoir un débit minimum de {byterate}"
  },
  "validation.file.video.minimumDuration": {
    "placeholders": {
      "duration": ["duration"]
    },
    "translation": "La vidéo doit avoir une durée minimum de {duration} secondes"
  },
  "version-drift.notification.action-reload": {
    "translation": "Mettre à jour"
  },
  "version-drift.notification.description": {
    "translation": "Vous pouvez terminer votre travail sur cette page avant de mettre à jour. L'application sera rechargée avec les dernières corrections et fonctionnalités."
  },
  "version-drift.notification.title": {
    "translation": "Une mise à jour de l'application est disponible"
  }
}
